const organizationPermissionKeys = new Set([
  "providers:personal",
  "models:read",
  "models:write",
  "tools:use",
  "mcp:manage",
  "skills:write",
  "agent-workspaces:use",
  "users:read",
  "users:write",
  "usage:read",
  "billing:read",
  "billing:manage",
  "audit:read",
  "organization:manage",
  "organization:auth:manage",
  "policies:manage",
  "automations:use",
  "automations:manage",
  "integrations:use",
  "integrations:manage",
  "projects:manage",
  "chat:use",
]);

const legacyPermissionAliases: Record<string, string> = {
  "tools:read": "tools:use",
};

export function normalizeOrganizationPermissions(value: string[]) {
  return [
    ...new Set(
      value
        .map((permission) => legacyPermissionAliases[permission] ?? permission)
        .filter((permission) => organizationPermissionKeys.has(permission)),
    ),
  ];
}
